import React from 'react'
import logo from '../images/Logo1.png'
import PropTypes from 'prop-types'

export default function Footer(props) {
  return (
    // <div className='bg ' style = {{
    //     backgroundImage:
    //     `url(./images/bg3.jpg)`,
        
    //  }}>
        <div className=''>
      
      <div className="flex flex-col">
      <div className=" mt-auto py-auto">
<footer   className='bg-'>
                 <section className='bg-gray-900 h-full'>
    <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div class="md:flex md:justify-between">
          <div class="mb-6 md:mb-0">
            <div className="w-28 rounded-lg bg-white shadow-2xl h-28 ">
                  <img src={logo} class="mx-auto w-24 my-auto me-3" alt="FlowBite Logo" />
                  {/* <span class="self-center text-2xl font-semibold whitespace-nowrap ">Jay</span> */}
                  </div>
          </div>
          <div class="grid grid-cols-1 gap-8 sm:gap-6 sm:grid-cols-2">
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-gray-400 uppercase ">Follow us</h2>
                  <ul class="text-gray-100  font-medium">
                      <li class="mb-4">
                          <a href="#" class="hover:underline ">Facebook</a>
                      </li>
                      <li>
                          <a href="#" class="hover:underline">Twitter</a>
                      </li>
                  </ul>
              </div>
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-gray-400 uppercase ">Legal</h2>
                  <ul class="text-gray-100  font-medium">
                      <li class="mb-4">
                          <a href="#" class="hover:underline">Privacy Policy</a>
                      </li>
                      <li>
                          <a href="#" class="hover:underline">Terms &amp; Conditions</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto  lg:my-8" />
      <div class="sm:flex sm:items-center sm:justify-between">
          <span class="text-sm text-gray-100 sm:text-center ">© 2024 <span class="hover:underline">Jay Malhar Mauli Roadways™</span>. All Rights Reserved.
          </span>
          <div class="flex mt-4 sm:justify-center sm:mt-0">
              <a href="#" class="text-gray-500 hover:text-gray-900 ">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 8 19">
                        <path fill-rule="evenodd" d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z" clip-rule="evenodd"/>
                    </svg>
                  <span class="sr-only">Facebook page</span>
              </a>
              <a href="#" class="text-gray-500 hover:text-gray-900  ms-5">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 20 17">
                    <path fill-rule="evenodd" d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z" clip-rule="evenodd"/>
                </svg>
                  <span class="sr-only">Twitter page</span>
              </a>
         
              <a href="#" class="text-gray-500 hover:text-gray-900  ms-5">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px"  fill="white" viewBox="0 0 50 50">
                    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
            </svg>
                  <span class="sr-only">LinkedIn</span>
              </a>
          </div>
      </div>
    </div>
    </section>
</footer>
</div>
</div>

    </div>
  )
}
